import * as Roles from '@/store/roles';

export const partCommentActionsPermissions = {
  addPartComment: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  getPartComments: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  getPartCommentsForPerson: [Roles.Any],
  syncPartComment: [Roles.Any],
};



// WEBPACK FOOTER //
// ./src/store/partComment/partCommentActionsPermissions.js